var render, staticRenderFns
import script from "./BackupsTable.vue?vue&type=script&lang=js&"
export * from "./BackupsTable.vue?vue&type=script&lang=js&"
import style0 from "./BackupsTable.vue?vue&type=style&index=0&id=aa63bcd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa63bcd0",
  null
  
)

export default component.exports